import type { QueryClient } from "@tanstack/react-query";

import { userStorage } from "@/lib/storage/user";
import type { User } from "@/types/auth";

import { userKeys } from "./user.keys";

export const updateGetMeCache = (
  queryClient: QueryClient,
  updater: (user: User | undefined) => User | undefined,
) => {
  const next = queryClient.setQueryData<User>(userKeys.me(), (prev) => updater(prev));
  if (next) {
    userStorage.set(next);
  } else {
    userStorage.clear();
  }
};

export const clearGetMeCache = (queryClient: QueryClient) => {
  userStorage.clear();
  queryClient.removeQueries({ queryKey: userKeys.me() });
};
